require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./rabais-epfl-1-10-1.json") })
        }
      }, "path---rabais-epfl-1-10-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---rabais-epfl-1-10-1!./.cache/json/rabais-epfl-1-10-1.json
// module id = 544
// module chunks = 231608221292675